module.exports = __webpack_public_path__ + "img/1970East-047_WEB-min.f474d8a2.jpg";